// @flow
export type CapacityValue = number | string | null | void;

export const getMaxCapacity = (value: CapacityValue): ?number => {
  const capacity = Number(value);

  return Number.isFinite(capacity) && capacity > 0 ? capacity : null;
};

export const resolveCapacity = (
  value: CapacityValue,
  defaultCapacity: CapacityValue
): string => {
  const capacity = String(value ?? "").trim();

  return capacity || String(defaultCapacity ?? "").trim();
};

export const getCapacityError = (
  value: CapacityValue,
  maxCapacity?: ?number,
  required?: boolean = true
): ?string => {
  if (!String(value ?? "").trim()) {
    return required ? "Required" : null;
  }

  const capacity = Number(value);

  if (!Number.isSafeInteger(capacity) || capacity <= 0) {
    return "Must be a positive whole number";
  }

  const maximum = getMaxCapacity(maxCapacity);

  return maximum !== null && capacity > maximum
    ? `Must be ${maximum} or fewer`
    : null;
};
